import { postRestoreOffer } from 'shared/api/hidden_objects';
import {
  EHideOfferAnalyticsCategory,
  ERestoreEventSource,
  selectProductsParams,
  trackHiddenObjects,
} from 'shared/tracking/hide_offer';

import { IThunkActionCreator } from '..';
import { setHideOfferState } from './actions';
import { EHideOfferState } from './types';
import { setOfferHidden } from '../offer';
import { errorMessages } from './hideOffer';

export function restoreOffer(eventSource?: ERestoreEventSource): IThunkActionCreator<Promise<void>> {
  return async (dispatch, getState, context) => {
    const offerId = getState().offerData.offer.id;

    dispatch(setHideOfferState({ status: EHideOfferState.FETCHING }));

    return postRestoreOffer(context.httpApi, { offerId })
      .then(result => {
        if (result.statusCode === 200) {
          dispatch(setHideOfferState({ status: EHideOfferState.SUCCESS }));
          dispatch(setOfferHidden(false));
          trackHiddenObjects({
            action: eventSource as string,
            category: EHideOfferAnalyticsCategory.RESTORE,
            productParams: selectProductsParams(getState()),
          });
        } else {
          dispatch(
            setHideOfferState({
              status: EHideOfferState.ERROR,
              errorMessage: errorMessages.errorWhileRestore,
            }),
          );
        }
      })
      .catch((error: Error) => {
        context.logger.error(error, { deatails: 'Failed to restore offer' });
        dispatch(
          setHideOfferState({
            status: EHideOfferState.ERROR,
            errorMessage: errorMessages.errorWhileRestore,
          }),
        );
      });
  };
}
